import { createFileRoute } from '@tanstack/react-router'
import { BookingDeletePage } from '@/features/bookings/delete'

export const Route = createFileRoute('/bookings_/$bookingId/delete')({
  component: BookingDeletePage,
})
